import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import VueGoogleMaps from "@fawmi/vue-google-maps";

import { IonicVue } from "@ionic/vue";

/* Core CSS required for Ionic components to work properly */
import "@ionic/vue/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/vue/css/normalize.css";
import "@ionic/vue/css/structure.css";
import "@ionic/vue/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/vue/css/padding.css";
import "@ionic/vue/css/float-elements.css";
import "@ionic/vue/css/text-alignment.css";
import "@ionic/vue/css/text-transformation.css";
import "@ionic/vue/css/flex-utils.css";
import "@ionic/vue/css/display.css";
import { DbParamType } from "./components/shared/DbParamType";
import { CommandExecutionType } from "./components/shared/CommandExecutionType";
import { ParameterDirection } from "./components/shared/ParameterDirection";
import { CommandParam } from "./components/shared/CommandParam";
import { dataBoxCall } from "./components/shared/GlobalCallSP";
import { UserCredential } from "./components/shared/UserCredential";
import { createI18n } from "vue-i18n/index";
import { store } from "./components/shared/store";

/* Theme variables */
import "./theme/variables.css";
import "./theme/tema.css";
import BaseLayout from "./components/base/BaseLayout.vue";
 
/*classe di utility*/
class sStore {
  constructor() {
    //window.localStorage =
    //  typeof window.localStorage === "undefined"
    //    ? undefined
    //    : window.localStorage;
    //this.supported = !(
    //  typeof storage == "undefined" || typeof window.JSON == "undefined"
    //);
  }

  static isObject(val) {
    if (val === null) {
      return false;
    }
    return typeof val === "function" || typeof val === "object";
  }
  /**
   * Pass any type of a string from the localStorage to be parsed so it returns a usable version (like an Object)
   * @param res - a string that will be parsed for type
   * @returns {*} - whatever the real type of stored value was
   */
  static parseValue(res) {
    var val;
    try {
      val = JSON.parse(res);
      if (typeof val == "undefined") {
        val = res;
      }
      if (val == "true") {
        val = true;
      }
      if (val == "false") {
        val = false;
      }
      if (parseFloat(val) == val && !this.isObject(val)) {
        val = parseFloat(val);
      }
    } catch (e) {
      val = res;
    }
    return val;
  }

  /**
   * Set - let's you set a new localStorage key pair set
   * @param key - a string that will be used as the accessor for the pair
   * @param value - the value of the localStorage item
   * @returns {*} - will return whatever it is you've stored in the local storage
   */
  static set(key, value) {
    var saver = JSON.stringify(value);
    window.localStorage.setItem(key, saver);
    return this.parseValue(saver);
  }
  /**
   * Get - let's you get the value of any pair you've stored
   * @param key - the string that you set as accessor for the pair
   * @returns {*} - Object,String,Float,Boolean depending on what you stored
   */
  static get(key) {
    var item = window.localStorage.getItem(key);
    return this.parseValue(item);
  }
  /**
   * Remove - let's you nuke a value from localStorage
   * @param key - the accessor value
   * @returns {boolean} - if everything went as planned
   */
  static remove(key) {
    window.localStorage.removeItem(key);
    return true;
  }
}

const messages = {
  it: {
    Aggiornamento: "Aggiornamento",
    "Attenzione!": "Attenzione!",
    Attività: "Attività",
    "Attività correlate": "Attività correlate",
    Categorie: "Categorie",
    "Cosa vorresti fare ?": "Cosa vorresti fare ?",
    "Errore durante il caricamento dati!": "Errore durante il caricamento dati!",
    Indietro: "Indietro",
    Informazioni: "Informazioni",
    "Percorso attività": "Percorso attività",
    Prosegui: "Prosegui",
    "Quanto tempo hai ?": "Quanto tempo hai ?",
    "Scegli la lingua per continuare": "Scegli la lingua per continuare",
    "Selezionare una lingua !": "Selezionare una lingua !",
    Naviga: "Naviga",
    Segnalazioni: "Invia la tua segnalazione riguardo la struttura, richiesta informazioni o altro, saremo lieti di rispondere",
    Motivo: "Specifica il motivo della tua segnalazione",
    errMotivo:"Specifica il motivo della tua segnalazione",
    Email: "Indica la tua e-mail",
    errEmail:"Indica la tua e-mail",
    Invia: "Conferma ed Invia",
    errSegnalazione:"Errore durante invio segnalazione",
    okSegnalazione:"Segnalazione inviata con successo!",
    Attenzione:"Attenzione",
    Grazie:"Grazie!",
    btnSegnalazioni:"Segnalazioni e <br/> richieste"
  },
  en: {
    Aggiornamento: "Update",
    "Attenzione!": "Warning!",
    Attività: "Activities",
    "Attività correlate": "Related activities",
    Categorie: "Category",
    "Cosa vorresti fare ?": "What would you like to do ?",
    "Errore durante il caricamento dati!": "Error loading data!",
    Indietro: "Back",
    Informazioni: "Information",
    "Percorso attività": "Activity path",
    Prosegui: "Continue",
    "Quanto tempo hai ?": "How much time do you have ?",
    "Scegli la lingua per continuare": "Choose the language to continue",
    "Selezionare una lingua !": "Select a Language !",
    Naviga: "Navigator",
    Segnalazioni: "Send your report regarding the structure, information request or other, we will be glad to answer",
    Motivo:"Specify the reason for your report",
    errMotivo:"Specify the reason for your report",
    Email:"Your email address",
    errEmail:"Insert your email address",
    Invia: "Send Request",
    errSegnalazione:"Error sending report",
    okSegnalazione:"Report sent successfully!",
    Attenzione:"Attention",
    Grazie:"Thanks!"
  },
  de: {
    Aggiornamento: "Aktualisierung",
    "Attenzione!": "Achtung!",
    Attività: "Aktivitäten",
    "Attività correlate": "ähnliche Aktivitäten",
    Categorie: "Kategorien",
    "Cosa vorresti fare ?": "Was würden Sie tun?",
    "Errore durante il caricamento dati!": "Fehler beim Laden der Daten!",
    Indietro: "Zurück",
    Informazioni: "Informationen",
    "Percorso attività": "Pfad Aktivitäten",
    Prosegui: "Fortsetzen",
    "Quanto tempo hai ?": "Wie viel Zeit haben Sie?",
    "Scegli la lingua per continuare": "Wählen Sie Ihre Sprache, um fortzufahren",
    "Selezionare una lingua !": "Wählen Sie eine Sprache!",
    Segnalazioni: "Stuur uw melding over de opbouw, informatieverzoek of iets anders, wij beantwoorden graag",
    Motivo:"Geef de reden voor uw melding op",
    errMotivo:"Geef de reden voor uw melding op",
    Email: "jouw e-mailadres",
    errEmail:"Vul je e-mailadres in",
    Invia: "Verzend verzoek",
    errSegnalazione:"Fout bij verzenden van rapport",
    okSegnalazione:"Rapport succesvol verzonden!",
    Attenzione:"Aandacht",
    Grazie :"Bedankt!"
  },
  es: {
    Aggiornamento: "Actualización",
    "Attenzione!": "¡Atención!",
    Attività: "Actividades",
    "Attività correlate": "Las actividades relacionadas",
    Categorie: "Categorías",
    "Cosa vorresti fare ?": "¿Qué quieres hacer?",
    "Errore durante il caricamento dati!": "Error durante la carta de los datos!",
    Indietro: "Regresar",
    Informazioni: "Información",
    "Percorso attività": "Las actividades del camino",
    Prosegui: "Continuar",
    "Quanto tempo hai ?": "¿Cuánto tiempo tienes?",
    "Scegli la lingua per continuare": "Elige tu idioma para continuar",
    "Selezionare una lingua !": "Seleccionar un idioma!",
    Segnalazioni: "Envíe su informe sobre la estructura, solicitud de información u otro, con gusto le atenderemos",
    Motivo:"Especifique el motivo de su denuncia",
    errMotivo:"Especifique el motivo de su denuncia",
    Email:"Su dirección de correo electrónico",
    errEmail:"Inserta tu dirección de correo electrónico",
    Invia: "Enviar petición",
    errSegnalazione:"Error al enviar informe",
    okSegnalazione:"¡Informe enviado con éxito!",
    Attenzione:"Atención",
    Grazie :"¡Gracias!"
  },
  fr: {
    Aggiornamento: "Ajourner",
    "Attenzione!": "Attention!",
    Attività: "Activités",
    "Attività correlate": "Activités connexes",
    Categorie: "Catégories",
    "Cosa vorresti fare ?": "Qu'est-ce que tu veux faire?",
    "Errore durante il caricamento dati!": "Une erreur est survenue lors du chargement!",
    Indietro: "Arrière",
    Informazioni: "Information",
    "Percorso attività": "Itinéraire",
    Prosegui: "Continuer",
    "Quanto tempo hai ?": "Combien de temps as-tu ?",
    "Scegli la lingua per continuare": "Choisissez votre langue pour continuer",
    "Selezionare una lingua !": "Choisir votre langue !",
    Segnalazioni: "Envoyez votre rapport concernant la structure, demande d'information ou autre, nous nous ferons un plaisir de vous répondre",
    Motivo:"Précisez la raison de votre signalement",
    errMotivo:"Précisez la raison de votre signalement",
    Email:"Votre adresse e-mail",
    errEmail:"Insérez votre adresse e-mail",
    Invia: "Envoyer une demande",
    errSegnalazione:"Erreur lors de l'envoi du rapport",
    okSegnalazione:"Rapport envoyé avec succès !",
    Attenzione:"Attention",
    Grazie :"Merci!"
  },
  pt: {
    Aggiornamento: "Atualizar",
    "Attenzione!": "Aviso!",
    Attività: "Atividades",
    "Attività correlate": "Atividades relacionadas",
    Categorie: "Categorias",
    "Cosa vorresti fare ?": "O que você faria?",
    "Errore durante il caricamento dati!": "O carregamento de dados de erro!",
    Indietro: "De volta",
    Informazioni: "Informação",
    "Percorso attività": "Atividades do caminho",
    Prosegui: "Continuar",
    "Quanto tempo hai ?": "O que fazer?",
    "Scegli la lingua per continuare": "Escolha o idioma para continuar",
    "Selezionare una lingua !": "Selecione um idioma!",
    Segnalazioni: "Envie seu relato sobre a estrutura, pedido de informação ou outro, teremos prazer em responder",
    Motivo:"Especifique o motivo do seu relatório",
    errMotivo:"Especifique o motivo do seu relatório",
    Email: "Seu endereço de email",
    errEmail:"Insira seu endereço de e-mail",
    Invia: "Enviar pedido",
    errSegnalazione:"Erro ao enviar relatório",
    okSegnalazione:"Relatório enviado com sucesso!",
    Attenzione:"Atenção",
    Grazie :"Obrigado!"
  },
};

function getLang() {
  //prende la lingua dalla path o dal browser
  //impostazione iniziale della lingua
  var lang;
  lang = sStore.get("Rst_codi");
  if (lang == undefined) {
    lang = window.navigator.userLanguage || window.navigator.language;
  }
  lang = lang.substr(0, 2);

  return lang;
}

const i18n = createI18n({
  //inizializzazione
  locale: getLang(),
  messages,
});

const app = createApp(App).use(IonicVue).use(router).use(i18n);

app.use(VueGoogleMaps, {
  load: {
    //key: "AIzaSyAGDdFSa1rS7pHUDuDTkiOgl0qcPni8r08",
    key:"AIzaSyAxXDXL-SQibozxGaL_3Wd-ECGcYRnVmFI"
  },
});

app.config.globalProperties.$API_AUTH_URL = "https://dbapimx.niemit.com/s/v1/JWTAuth.ashx";
app.config.globalProperties.$API_DBOX_URL = "https://dbapimx.niemit.com/s/DataBoxService.ashx";
app.config.globalProperties.$API_KEY =
  "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhdXQiOiIiLCJ3Y2siOiJrMlhvdlpBcUJ3NTJFTG96ekExZlRHdlFaTHFuQm5iN3hoQUtxM0NsRVRXM2k1UElaTCIsInd3YyI6NDF9.1UwX5iWCOehL4JDMq92KWSrZP29sLeEgCkHRtlWvpNA";
app.config.globalProperties.$SITE_URL = "https://dbapimx.niemit.com";
//app.config.globalProperties.$USR_NUTE =
//app.config.globalProperties.$USR_PSWD = "zTSUkxYxbn2Uis0O43XJr8GGNxWjtx";
app.config.globalProperties.$CON_TOKE = "21zVp2FeJe";
app.config.globalProperties.$IND_CODI = "1";
app.config.globalProperties.$LIN_CODI = 96;
app.config.globalProperties.$USER = new UserCredential();
app.config.globalProperties.$axios = axios;
//app.config.globalProperties.$FOOTER = {};

app.component("base-layout", BaseLayout);
//console.log(DbParamType.AnsiString);

router.isReady().then(() => {
  let usr = app.config.globalProperties.$USER;
  usr.Usr_nute = "nmtuserapp";

  usr.Www_akey = app.config.globalProperties.$API_KEY;
  usr.RegNewUser = false;
  usr.Usr_vkey = "";

  if (sStore.get("token") != undefined && sStore.get("token") != "null") {
    usr.JwtToken = sStore.get("token"); // $window.sessionStorage.token;
  }
  usr.Usr_pswd = "zTSUkxYxbn2Uis0O43XJr8GGNxWjtx";
  store.Rst_codi = 'it'

  app.config.globalProperties
    .$axios({
      method: "post",
      url: app.config.globalProperties.$API_AUTH_URL,
      crossDomain: true,
      data: usr,
    })  
    .then(
      //funzione ok
      function (response) {
        if (typeof response.data === "object") {
          //procedo con il caricamento dei dati
          // //e delle viste!
          //in base alla route carico i dati che mi servono
          if (response.data.JwtToken) {
            usr.JwtToken = response.data.JwtToken;

            sStore.set("token", usr.JwtToken);
            usr.Usr_anon = response.data.Usr_anon;
            if (!usr.Usr_anon) {
              usr.Per_nome = response.data.Per_nome;
            } else {
              usr.Per_nome = "";
            }

            //se la sessione ha lingua diversa
            //la reimposto
            //if (usr.Rst_codi != response.data.Rst_codi) {
            //  var lng = response.data.Rst_codi;
            //  lng = lng.substr(0, 2);
            //  sStore.set(APP_ID + "lng", lng);
            //  usr.Rst_codi = lng;
            //  i18n.locale = lng;
            //  //imposto lingua dello scope
            //}

            //estraggo i dati avendo il token
            //provo ad estrarre dati con GLobalcallsp
            //Model footer

            let prm = [];
            prm.push(new CommandParam("@Con_toke", "", DbParamType.AnsiString, 10, ParameterDirection.Input, app.config.globalProperties.$CON_TOKE));
            prm.push(new CommandParam("@Ind_codi", "", DbParamType.AnsiString, 10, ParameterDirection.Input, app.config.globalProperties.$IND_CODI));

            //Definisco oggetto per la configurazione del databox
            app.config.globalProperties.$DATABOX_CFG = {
              $API_KEY: app.config.globalProperties.$API_KEY,
              $API_DBOX_URL: app.config.globalProperties.$API_DBOX_URL,
              $JwtToken: usr.JwtToken,
            };

            //GlobalCallSP.Exec()
            dataBoxCall
              .Exec(
                prm,
                "stpF_Anagrafica_IndirizziSysApp01_src",
                true,
                "Errore durante esecuzione procedura!",
                CommandExecutionType.ExecuteQuery,
                false,
                app.config.globalProperties.$DATABOX_CFG
              )
              .then(function (data) {
                // ngToast.create({
                //   className: 'success',
                //   content: 'Record salvato correttamente !',
                //   dismissOnTimeout: true,
                //   dismissButton: true
                // });
                if (data) {
                  console.log("return normale");
                  store.set({
                    Con_rag1: data.RecordSet.Table[0]["Con_rag1"],
                    Ind_loc1: data.RecordSet.Table[0]["Ind_loc1"],
                    Ind_ind1: data.RecordSet.Table[0]["Ind_ind1"],
                    Cap_cod1: data.RecordSet.Table[0]["Cap_cod1"],
                    Naz_cod1: data.RecordSet.Table[0]["Naz_cod1"],
                    Com_cod1: data.RecordSet.Table[0]["Com_cod1"],
                    Ind_tel1: data.RecordSet.Table[0]["Ind_tel1"],
                    Ind_ema1: data.RecordSet.Table[0]["Ind_ema1"],
                    Inf_gatc: data.RecordSet.Table[0]["Inf_gatc"],
                    //"balPrope"r:ies.$FOOTER
                  });
                } else {
                  console.log("return normale no data");
                }

                // eslint-disable-next-line no-unused-vars
                app.mount("#app");
                //eseguo connessione
                //usr.Rst_codi = getLang(usr);
              })
              .catch(function (data) {
                if (data) {
                  console.log("return normale");
                } else {
                  console.log("return normale no data");
                }
              });
          }
        } else {
          // invalid response
          Promise.reject(response.data);
        }
        usr.Rst_codi = getLang(); //imposto lingua corrente utente
        store.setRst_codi(getLang());
        sStore.set("Rst_codi", store.Rst_codi);
      },
      //funzione no ok
      function (response) {
        // something went wrong
        ///_app.ready = false;
        Promise.reject(response.data);
      }
    );
});
